import React from 'react';
import styled from 'styled-components';
import { fontSize } from '../../../../../constants/text';
import { colors } from '../../../../../constants/colors';

const GenericRow = styled.div.withConfig({ componentId: 'sc-ruh526-0' })`
  font-size: ${fontSize.default};
  padding: 16px 24px;
  border-top: 1px solid ${colors.fatherJohnMisty};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
`;

export default GenericRow;
